export default {
  Panel: {
    bg: "#fff",
    border: "1px solid",
    borderRadius: "none",
    borderColor: "gray.300",
  },
};
